import { store } from '../../../store'
import { MessageDataType } from '../types'
import {
  clearOrderBook,
  getOrderbookAction,
  incrementalOrderbookAction,
} from '../../../store/orderbook/actions'
import { Price, Quantity, SymbolId, SymbolName } from '../../../types'
import { OrderDirection } from '../../../store/spot/types'

export interface WsOrderbookData {
  type: 'orderbook'
  lastSequenceId: number
  symbol: SymbolName
  sequenceId: number
  data: {
    symbolId: SymbolId
    sequenceId: number
    price: Price
    direction: OrderDirection
    buyOrders: [Price, Quantity][]
    sellOrders: [Price, Quantity][]
    symbol: SymbolName
  }
}

export function onMessageOrderbook(data: MessageDataType) {
  switch (data.type) {
    // Receive incremental orderbook data of the current symbol, used to display in the 'OrderList' component
    case 'orderbook':
      updateOrderbook(data as WsOrderbookData)
      break
  }
}

function updateOrderbook(data: WsOrderbookData) {
  const state = store.getState()
  const { orderbook } = state.orderbook
  const { symbol, sequenceId, lastSequenceId } = data

  // If the local orderbook has sequenceId and the received data has lastSequenceId,
  // it means that the data is incremental orderbook data.
  // Next we need to determine whether the sequenceId of the received data is continuous.
  if (orderbook.sequenceId && lastSequenceId) {
    const isCurrentSymbol = orderbook.symbol === symbol
    const isSequenceJumped = lastSequenceId !== orderbook.sequenceId

    // If the current symbol is not the same as the symbol of the received data, ignore it
    if (isCurrentSymbol && isSequenceJumped) {
      console.warn('sequence jumped', sequenceId, orderbook.lastSequenceId)
      store.dispatch(clearOrderBook())
      store.dispatch(getOrderbookAction(symbol))
      return
    }
  }

  // If the received data is incremental orderbook data, update the orderbook
  store.dispatch(incrementalOrderbookAction(data))
}
